import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Enter Mobile Number": "Enter Mobile Number",
      "Please Enter Mobile Number": "Please Enter Mobile Number",
      "We will send you an OTP on this mobile number, if not registered you can start the fresh registration": 
        "We will send you an OTP on this mobile number, if not registered you can start the fresh registration",
      "SEND OTP": "SEND OTP",
      "Sending...": "Sending...",
      "Enter OTP": "Enter OTP",
      "An OTP has been sent to": "An OTP has been sent to",
      "Enter 6 digit OTP": "Enter 6 digit OTP",
      "Didn't receive?": "Didn't receive?",
      "Resend OTP": "Resend OTP",
      "Verifying...": "Verifying...",
      "Continue": "Continue",
      "Error": "Error",
      "OK": "OK",
      "Failed to verify OTP": "Failed to verify OTP",
      "Please enter a valid 6-digit OTP.": "Please enter a valid 6-digit OTP.",
      "Video Tutorials": "Video Tutorials",
      "Upload Stepwise Images": "Upload Stepwise Images",
      "Role and Location Selection": "Role and Location Selection",
      "Digital Record": "Digital Record",
      "Help & Support": "Help & Support",
      "Profile & Settings": "Profile & Settings",
      "Logout": "Logout",
      "Internet": "Internet",
      "Connected": "Connected",
      "Sync": "Sync",
      "Completed": "Completed",
      "Are you sure you want to logout?": "Are you sure you want to logout?",
      "Language": "Language",
      "Select Language": "Select Language",
      "Cancel": "Cancel",
      "Confirm": "Confirm",
      "Invalid mobile number": "Invalid mobile number",
      "Mobile number is required": "Mobile number is required",
      "video_tutorials":"Video Tutorials",
      "App for Forest Rights Committee (FRC)":"App for Forest Rights Committee (FRC)"
    }
  },
  hi: {
    translation: {
      "Enter Mobile Number": "मोबाइल नंबर दर्ज करें",
      "Please Enter Mobile Number": "कृपया मोबाइल नंबर दर्ज करें",
      "We will send you an OTP on this mobile number, if not registered you can start the fresh registration": 
        "हम आपको इस मोबाइल नंबर पर एक ओटीपी भेजेंगे, यदि पंजीकृत नहीं है तो आप नया पंजीकरण शुरू कर सकते हैं",
      "SEND OTP": "ओटीपी भेजें",
      "Sending...": "भेजा जा रहा है...",
      "Enter OTP": "ओटीपी दर्ज करें",
      "An OTP has been sent to": "एक ओटीपी भेजा गया है",
      "Enter 6 digit OTP": "6 अंकों का ओटीपी दर्ज करें",
      "Didn't receive?": "नहीं मिला?",
      "Resend OTP": "ओटीपी पुनः भेजें",
      "Verifying...": "सत्यापन हो रहा है...",
      "Continue": "जारी रखें",
      "Error": "त्रुटि",
      "OK": "ठीक",
      "Failed to verify OTP": "ओटीपी सत्यापित करने में विफल",
      "Please enter a valid 6-digit OTP.": "कृपया एक मान्य 6 अंकों का ओटीपी दर्ज करें।",
      "Video Tutorials": "वीडियो ट्यूटोरियल्स",
      "Upload Stepwise Images": "चरणवार छवियों को अपलोड करें",
      "Role and Location Selection": "भूमिका और स्थान चयन प्रक्रिया",
      "Digital Record": "डिजिटल रिकॉर्ड",
      "Help & Support": "सहायता और समर्थन",
      "Profile & Settings": "प्रोफ़ाइल और सेटिंग्स",
      "Logout": "लॉगआउट",
      "Internet": "इंटरनेट",
      "Connected": "कनेक्टेड",
      "Sync": "सिंक",
      "Completed": "पूरा हुआ",
      "Are you sure you want to logout?": "क्या आप वाकई लॉगआउट करना चाहते हैं?",
      "Language": "भाषा",
      "Select Language": "भाषा चुनें",
      "Cancel": "रद्द करें",
      "Confirm": "पुष्टि करें",
      "Invalid mobile number": "अमान्य मोबाइल नंबर",
      "Mobile number is required": "मोबाइल नंबर आवश्यक है",
      "Step 1: Community Forest Right (CFR) Claim under FRA 2006": "चरण 1: एफआरए 2006 के तहत सामुदायिक वन अधिकार (सीएफआर) दावा",
      "Step 2: Community Forest Right (CFR) Claim under FRA 2006": "चरण 2: एफआरए 2006 के तहत सामुदायिक वन अधिकार (सीएफआर) दावा",
      "Step 3 and 4: Joint Meeting with Neighboring Villages and Physical Verification": "चरण 3 और 4: पड़ोसी गांवों के साथ संयुक्त बैठक और भौतिक सत्यापन",
      "Step 5: Final Gram Sabha for the Submission of Community Forest Resource Claim under FRA 2006": "चरण 5: एफआरए 2006 के तहत सामुदायिक वन संसाधन दावे के प्रस्तुतिकरण के लिए अंतिम ग्राम सभा",
      "video_tutorials":"वीडियो ट्यूटोरियल्स",
      "App for Forest Rights Committee (FRC)":"वन अधिकार समिति (FRC) के लिए ऐप"
    }
  },
  or: {
    translation: {
      "Enter Mobile Number": "ମୋବାଇଲ୍ ନମ୍ବର ଦାଖଲ କରନ୍ତୁ",
      "Please Enter Mobile Number": "ଦଯାକରି ମୋବାଇଲ୍ ନମ୍ବର ଦାଖଲ କରନ୍ତୁ",
      "We will send you an OTP on this mobile number, if not registered you can start the fresh registration": 
        "ଆମେ ଏହି ମୋବାଇଲ୍ ନମ୍ବରରେ ଆପଣଙ୍କୁ ଏକ ଓଟିପି ପଠାଇବୁ, ଯଦି ପଞ୍ଜୀକୃତ ନୁହେଁ, ତେବେ ନୂତନ ପଞ୍ଜିକରଣ ଆରମ୍ଭ କରିପାରିବେ",
      "SEND OTP": "ଓଟିପି ପଠାନ୍ତୁ",
      "Sending...": "ପଠାଯାଉଛି...",
      "Enter OTP": "ଓଟିପି ପ୍ରବେଶ କରନ୍ତୁ",
      "An OTP has been sent to": "ଏକ ଓଟିପି ପଠାଯାଇଛି",
      "Enter 6 digit OTP": "6 ଅଙ୍କର ଓଟିପି ପ୍ରବେଶ କରନ୍ତୁ",
      "Didn't receive?": "ମିଳିଲା ନାହିଁ?",
      "Resend OTP": "ଓଟିପି ପୁନଃ ପଠାନ୍ତୁ",
      "Verifying...": "ସତ୍ୟପାଇଁ ପରିକ୍ଷା ହେଉଛି...",
      "Continue": "ଚାଲନ୍ତୁ",
      "Error": "ଭୁଲି",
      "OK": "ଠିକ",
      "Failed to verify OTP": "ଓଟିପି ସତ୍ୟାପନ ବିଫଳ",
      "Please enter a valid 6-digit OTP.": "ଦଯାକରି ଏକ ବୈଧ 6 ଅଙ୍କର ଓଟିପି ପ୍ରବେଶ କରନ୍ତୁ।",
      "Video Tutorials": "ଭିଡିଓ ଟୁଟୋରିଆଲ୍ସ",
      "Upload Stepwise Images": "ପଦକ୍ଷେପ ଅନୁଯାୟୀ ଚିତ୍ରଗୁଡ଼ିକ ଅପଲୋଡ୍ କରନ୍ତୁ",
      "Role and Location Selection": "ଭୂମିକା ଓ ଅବସ୍ଥାନ ଚୟନ",
      "Digital Record": "ଡିଜିଟାଲ୍ ରେକର୍ଡ",
      "Help & Support": "ସାହାଯ୍ୟ ଓ ସମର୍ଥନ",
      "Profile & Settings": "ପ୍ରୋଫାଇଲ୍ ଏବଂ ସେଟିଂସ୍",
      "Logout": "ଲଗ୍ ଆଉଟ୍",
      "Internet": "ଇଣ୍ଟରନେଟ୍",
      "Connected": "ସଂଯୋଜିତ",
      "Sync": "ସମନ୍ୱୟ",
      "Completed": "ସମାପ୍ତ",
      "Are you sure you want to logout?": "ଆପଣ ନିଶ୍ଚିତ ଯେ ଆପଣ ଲଗ୍ ଆଉଟ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି?",
      "Language": "ଭାଷା",
      "Select Language": "ଭାଷା ବାଛନ୍ତୁ",
      "Cancel": "ବାତିଲ୍",
      "Confirm": "ପୁଷ୍ଟି",
      "Invalid mobile number": "ଅବୈଧ ମୋବାଇଲ୍ ନମ୍ବର",
      "Mobile number is required": "ମୋବାଇଲ୍ ନମ୍ବର ଆବଶ୍ୟକ",
      "Step 1: Community Forest Right (CFR) Claim under FRA 2006": "ପଦକ୍ଷେପ 1: ଏଫଆରଏ 2006 ଅନୁସାରେ ସମୁଦାୟ ଜଙ୍ଗଲ ଅଧିକାର (ସିଏଫଆର) ଦାବି",
      "Step 2: Community Forest Right (CFR) Claim under FRA 2006": "ପଦକ୍ଷେପ 2: ଏଫଆରଏ 2006 ଅନୁସାରେ ସମୁଦାୟ ଜଙ୍ଗଲ ଅଧିକାର (ସିଏଫଆର) ଦାବି",
      "Step 3 and 4: Joint Meeting with Neighboring Villages and Physical Verification": "ପଦକ୍ଷେପ 3 ଏବଂ 4: ପଡ଼ୋଶୀ ଗାଁଗୁଡ଼ିକ ସହିତ ଯୁକ୍ତ ସଭା ଏବଂ ଭୌତିକ ସତ୍ୟାପନ",
      "Step 5: Final Gram Sabha for the Submission of Community Forest Resource Claim under FRA 2006": "ପଦକ୍ଷେପ 5: ଏଫଆରଏ 2006 ଅନୁସାରେ ସମୁଦାୟ ଜଙ୍ଗଲ ସଂସାଧନ ଦାବି ପ୍ରଦାନ ପାଇଁ ଶେଷ ଗ୍ରାମ ସଭା",
      "video_tutorials":"ଭିଡିଓ ପାଠ୍ୟକ୍ରମ",
      "App for Forest Rights Committee (FRC)":"ବନ ଅଧିକାର ସମିତି (FRC) ପାଇଁ ଏପ୍"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
